import React, { Component } from 'react';
import styled from 'styled-components';
import { TransitionMotion, spring } from 'react-motion';
import H1 from '../H1';
import P from '../P';
import SocialLinks from '../SocialLinks';
import ContactLink from '../ContactLink';
import ScrollIndicator from '../ScrollIndicator';
import MyImage from '../../images/gauti-selvaraj.png';
import { media } from '../../utils/style';

const leavingSpringConfig = { stiffness: 60, damping: 15 };

const IntroWrap = styled.div`
  background-color: ${props => props.theme.black};
  min-height: 100vh;
  position: relative;
  overflow: hidden;
`;

const Circle = styled.div`
  border: ${props => `1px solid ${props.theme.main}`};
  border-radius: 50%;
  height: 3rem;
  position: absolute;
  width: 3rem;
  will-change: opacity, transform;
`;

const IntroContentWrapper = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  min-height: 100vh;
  position: relative;
  z-index: 2;

  ${media.tablet`
    padding-bottom: 50px;
  `};
`;

const IntroContent = styled.div`
  padding: 10px;
  text-align: center;
`;

const IntroText = styled.div`
  margin-bottom: 2rem;
  margin-top: 1.5rem;
`;

const ScrollIndicatorWrap = styled.div`
  bottom: 10px;
  display: none;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);

  ${media.tablet`
    display: inline-block;
  `};
`;

export default class IntroSection extends Component {
  constructor(props) {
    super(props);
    this.state = { mouse: [], now: 't' + 0 };
  }

  handleMouseMove = ({ pageX, pageY }) => {
    // Make sure the state is queued and not batched.
    this.setState(() => {
      return {
        mouse: [pageX - 25, pageY - 25],
        now: 't' + Date.now()
      };
    });
  };

  handleTouchMove = e => {
    this.handleMouseMove(e.touches[0]);
  };

  willLeave = styleCell => {
    return {
      ...styleCell.style,
      opacity: spring(0, leavingSpringConfig),
      scale: spring(2, leavingSpringConfig)
    };
  };

  scrollToNextPage = () => {
    window.scroll({ top: this.parentRef.offsetHeight, behavior: 'smooth' });
  };

  render() {
    const {
      mouse: [mouseX, mouseY],
      now
    } = this.state;
    const styles =
      mouseX == null
        ? []
        : [
            {
              key: now,
              style: {
                opacity: spring(1),
                scale: spring(0),
                x: spring(mouseX),
                y: spring(mouseY)
              }
            }
          ];

    return (
      <TransitionMotion willLeave={this.willLeave} styles={styles}>
        {circles => (
          <IntroWrap
            onMouseMove={this.handleMouseMove}
            onTouchMove={this.handleTouchMove}
            onScroll={this.handleScroll}
            innerRef={ele => (this.parentRef = ele)}
          >
            {circles.map(({ key, style: { opacity, scale, x, y } }) => (
              <Circle
                key={key}
                style={{
                  opacity: opacity,
                  transform: `translate3d(${x}px, ${y}px, 0) scale(${scale})`,
                  WebkitTransform: `translate3d(${x}px, ${y}px, 0) scale(${scale})`
                }}
              />
            ))}
            <IntroContentWrapper>
              <IntroContent itemScope itemType="http://schema.org/Person">
                <img
                  src={MyImage}
                  width={250}
                  itemProp="image"
                  alt="Gowtham Selvaraj (Gauti)"
                />
                <IntroText>
                  <H1 inverse>
                    Hi, I'm <span itemProp="name">Gowtham Selvaraj</span> (<span itemProp="additionalName">
                      Gauti
                    </span>),
                  </H1>
                  <P inverse bigger>
                    a{' '}
                    <span itemProp="jobTitle">
                      Full Stack JavaScript Engineer
                    </span>{' '}
                    based in{' '}
                    <span
                      itemProp="address"
                      itemScope
                      itemType="http://schema.org/PostalAddress"
                    >
                      {' '}
                      <span itemProp="addressLocality">Christchurch</span>,{' '}
                      <span itemProp="addressCountry">New Zealand</span>.
                    </span>
                  </P>
                </IntroText>
                <ContactLink />
                <SocialLinks />
                <ScrollIndicatorWrap>
                  <ScrollIndicator inverse onClick={this.scrollToNextPage} />
                </ScrollIndicatorWrap>
              </IntroContent>
            </IntroContentWrapper>
          </IntroWrap>
        )}
      </TransitionMotion>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/IndexComponents/IntroSection.js